// export const BACKEND_URL = "http://localhost:4002"

export const BACKEND_URL = "https://mern-jz7o.onrender.com"
